import $ from 'jquery'

/**
 * Checks if the text direction of the HTML document is Right-to-Left (RTL).
 *
 * This function verifies the 'dir' attribute of the HTML element to determine
 * if the text direction is set to 'rtl'. It's useful for adapting UI components
 * and behaviors in RTL environments.
 *
 * @returns {boolean} True if the document's text direction is RTL, false otherwise.
 */
function isRtl() {
  return $('html').attr('dir') === 'rtl'
}

export default isRtl

isRtl.__filename__ = 'components/is-rtl.js'
